
  import {createControllersWithDescriptors, initAppForPageWrapper} from '@wix/yoshi-flow-editor/runtime/esm/viewerScript/wrapper.js';
  
  
            
import wrapController0 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller0 from '/home/builduser/work/604972c8b164a1dd/packages/restaurants-order-tracker/src/components/Map/viewer.controller.ts';
            import * as _controllerExport0 from '/home/builduser/work/604972c8b164a1dd/packages/restaurants-order-tracker/src/components/Map/model.ts';
            var controllerExport0 = _controllerExport0;
            

            
import wrapController1 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller1 from '/home/builduser/work/604972c8b164a1dd/packages/restaurants-order-tracker/src/components/Tracker/viewer.controller.ts';
            import * as _controllerExport1 from '/home/builduser/work/604972c8b164a1dd/packages/restaurants-order-tracker/src/components/Tracker/model.ts';
            var controllerExport1 = _controllerExport1;
            

            
import wrapController2 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller2 from '/home/builduser/work/604972c8b164a1dd/packages/restaurants-order-tracker/src/components/trackingPage/viewer.controller.ts';
            import * as _controllerExport2 from '/home/builduser/work/604972c8b164a1dd/packages/restaurants-order-tracker/src/components/trackingPage/model.ts';
            var controllerExport2 = _controllerExport2;
            

  
  var importedApp = {};


  

    import { initState, initBind } from '@wix/yoshi-flow-editor/runtime/esm/velocycleMobx';
    import { observable } from 'mobx';
    var velocycleMobx = { initState, initBind, observable };
    


  

    import { blocksControllerService } from '@wix/yoshi-flow-editor/runtime/esm/blocks/controllerService'
    

  
var createHttpClient = null;

  

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
      DSN: 'https://4ef081b58ba84a148f3f5af23ad29457@sentry-next.wixpress.com/9411',
      id: '9411',
      projectName: 'restaurants-order-tracker',
      teamName: 'restaurants',
      errorMonitor: true,
    };

  var experimentsConfig = {"centralized":true,"scopes":[]};

  var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/604972c8b164a1dd/packages/restaurants-order-tracker/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};

  var defaultTranslations = {"tracker.editor.page.title":"Order Tracking Page","tracker.page.order-id.empty-state":"None","tracker.page.pickup-details.title":"Pickup Details","tracker.page.delivery-details.title":"Delivery Details","tracker.page.unknown-fulfillment-details.title":"Order Details","tracker.page.delivery-details.address.title":"Delivery to:","tracker.page.pickup-details.address.title":"Pickup from:","tracker.page.unknown-fulfillment-details.created-date.title":"Created at:","tracker.page.pickup-details.instruction.title":"Pickup instruction:","tracker.page.delivery-details.due-by.title":"Delivery time:","tracker.page.pickup-details.due-by.title":"Pickup time:","tracker.page.order-details.order-note.title":"Order notes:","tracker.status.order-pending.title":"Pending","tracker.status.order-accepted.title":"Accepted","tracker.status.order-ready.title":"Ready","tracker.status.order-out-for-delivery.title":"Out For Delivery","tracker.status.order-fulfilled.title":"Fulfilled","tracker.status.order-canceled.title":"Canceled","tracker.status.order-unknown.title":"Unknown","tracker.status.order-pending.description":"Your order was received and it’s status will be updated here","tracker.status.order-accepted.description":"Your order was accepted and will be prepared accordingly.","tracker.status.order-ready.description":"Your order is ready","tracker.status.order-out-for-delivery.description":"Your order is on it’s way","tracker.status.order-fulfilled.description":"Enjoy your order!","tracker.status.order-canceled.description":"Your order was canceled","tracker.status.order-unknown.description":"Unknown","tracker.page.editor.dispatch.title":"Dispatch details","tracker.page.editor.dispatch.address.title":"Address:","tracker.page.editor.dispatch.address.details":"Street, City, State, Zip Code, Country","tracker.page.editor.dispatch.order-notes.title":"Order notes:","tracker.page.editor.dispatch.order-notes.details":"Your customer's notes will be displayed here.","tracker.page.editor.dispatch.date-and-time.title":"Date & time:","tracker.page.editor.dispatch.date-and-time.details":"Sunday, 01/01/2025, 10:00 AM","tracker.status.editor.order-status.title":"Status","tracker.status.editor.order-status.description":"You'll see the status description here.","tracker.page.title":"Order Tracking","tracker.page.order-number.label":"Order number:","tracker.status.label":"Order status","tracker.error.text":"Couldn't load tracker due to\na technical issue.","tracker.page.editor.design-panel.global.panel-title":"Tracking Page Design","tracker.page.editor.design-panel.global.labels.page-title":"Page title","tracker.page.editor.design-panel.global.labels.order-status-title":"Order status","tracker.page.editor.design-panel.global.labels.subtitles":"Subtitles","tracker.page.editor.design-panel.global.labels.fulfillment-details-field-titles":"Section labels","tracker.page.editor.design-panel.global.labels.body-texts":"Main text","tracker.page.editor.design-panel.global.labels.divider":"Divider","tracker.page.editor.design-panel.global.labels.global-widget":"Background","tracker.page.editor.design-panel.heading.panel-title":"Header Design","tracker.page.editor.design-panel.heading.labels.title":"Title","tracker.page.editor.design-panel.heading.labels.description":"Order number","tracker.page.editor.design-panel.status.panel-title":"Order Status Design","tracker.page.editor.design-panel.status.labels.box-title":"Title","tracker.page.editor.design-panel.status.labels.status-title":"Status","tracker.page.editor.design-panel.status.labels.texts":"Main text","tracker.page.editor.design-panel.status.labels.status-box":"Background","tracker.page.editor.design-panel.fulfillment-details.panel-title":"Fulfillment Design","tracker.page.editor.design-panel.fulfillment-details.labels.subtitles":"Section title","tracker.page.editor.design-panel.fulfillment-details.labels.field-titles":"Section labels","tracker.page.editor.design-panel.fulfillment-details.labels.field-texts":"Main text","tracker.page.editor.design-panel.fulfillment-details.labels.divider":"Divider","tracker.page.editor.design-panel.fulfillment-details.labels.fulfillment-details-box":"Background","tracker.page.editor.widget-name.root":"Order Tracking","tracker.page.editor.widget-name.page-header":"Header","tracker.page.editor.widget-name.status-container":"Order Status","tracker.page.editor.widget-name.fulfillment-details-container":"Fulfillment Details","tracker.page.editor.gfpps.main-action-1.open-prep-board":"Manage Orders"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/604972c8b164a1dd/packages/restaurants-order-tracker/target/generated/bi/createBILogger.ts';

  export const exports = importedApp.exports;

  export const initAppForPage = initAppForPageWrapper({
    initAppForPage: importedApp.initAppForPage,
    sentryConfig: sentryConfig,
    experimentsConfig: experimentsConfig,
    inEditor: false,
    biLogger: biLogger,
    multilingualDisabled,
    projectName: "restaurants-order-tracker",
    biConfig: null,
    appName: "Restaurants Tracker app",
    appDefinitionId: "e329a4ab-e1b2-4268-9cc6-ac6f77ec6767",
    fedopsConfig: fedopsConfig,
    translationsConfig: translationsConfig,
    defaultTranslations: defaultTranslations,
    shouldUseEssentials: true,
    optionalDeps: {
      initI18n,
      createHttpClient,
      createExperiments,
    },
    localeDistPath: "assets/locales",
  });

  const _createControllers = createControllersWithDescriptors({
    initI18n,
    blocksControllerService,
    createHttpClient,
    createExperiments,
    velocycleMobx,
  }, [{ method: controller0,
          wrap: wrapController0,
          exports: controllerExport0,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/604972c8b164a1dd/packages/restaurants-order-tracker/src/components/Map/viewer.controller.ts",
          appName: "Restaurants Tracker app",
          appDefinitionId: "e329a4ab-e1b2-4268-9cc6-ac6f77ec6767",
          projectName: "restaurants-order-tracker",
          componentName: "Map",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "e329a4ab-e1b2-4268-9cc6-ac6f77ec6767-dg4og" }, { method: controller1,
          wrap: wrapController1,
          exports: controllerExport1,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/604972c8b164a1dd/packages/restaurants-order-tracker/src/components/Tracker/viewer.controller.ts",
          appName: "Restaurants Tracker app",
          appDefinitionId: "e329a4ab-e1b2-4268-9cc6-ac6f77ec6767",
          projectName: "restaurants-order-tracker",
          componentName: "Tracker",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "e329a4ab-e1b2-4268-9cc6-ac6f77ec6767-x91qr" }, { method: controller2,
          wrap: wrapController2,
          exports: controllerExport2,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/604972c8b164a1dd/packages/restaurants-order-tracker/src/components/trackingPage/viewer.controller.ts",
          appName: "Restaurants Tracker app",
          appDefinitionId: "e329a4ab-e1b2-4268-9cc6-ac6f77ec6767",
          projectName: "restaurants-order-tracker",
          componentName: "trackingPage",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "e329a4ab-e1b2-4268-9cc6-ac6f77ec6767-euxz6" }],
    false);

    export const createControllers = _createControllers
